import { render, staticRenderFns } from "./RewardBoxSelection.vue?vue&type=template&id=d10200d0"
import script from "./RewardBoxSelection.vue?vue&type=script&lang=js"
export * from "./RewardBoxSelection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports